import { TextField } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { FormCard } from "../../../../components";
import { TextAreaWithCount } from "../../../../components/Inputs";

export interface GuardianData {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  note: string;
}

interface IProps {
  guardianData: GuardianData;
  onUpdate: (guardianData: Partial<GuardianData>) => void;
}

export const GuardianAccordion = ({
  guardianData: { firstName, lastName, phoneNumber, email, note },
  onUpdate,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <FormCard className="position-relative">
      <Row className="mb-2">
        <Col md={3}>
          <TextField
            label={t("person.firstName")}
            value={firstName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({ firstName: e.target.value })
            }
            maxLength={50}
          />
        </Col>
        <Col md={3}>
          <TextField
            label={t("person.lastName")}
            value={lastName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({ lastName: e.target.value })
            }
            maxLength={50}
          />
        </Col>
        <Col md={3}>
          <TextField
            label={t("person.phoneNumber")}
            value={phoneNumber}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({ phoneNumber: e.target.value })
            }
            maxLength={30}
          />
        </Col>
        <Col md={3}>
          <TextField
            label={t("person.email")}
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              onUpdate({ email: e.target.value })
            }
            maxLength={254}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <TextAreaWithCount
            ariaLabel={t("person.note")}
            label={t("person.note")}
            value={note}
            onChange={(value) => onUpdate({ note: value })}
            rows={3}
            maxLength={254}
          />
        </Col>
      </Row>
    </FormCard>
  );
};
